import { useEffect, useState } from "react";

const TABLET_MIN = 768;
const TABLET_MAX = 1024;

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(() => {
    if (typeof window === "undefined") return false;

    const width = window.innerWidth;
    return width >= TABLET_MIN && width <= TABLET_MAX;
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsTablet(width >= TABLET_MIN && width <= TABLET_MAX);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isTablet;
};
